<template>
<div>
	<!-- label v-bind:class="[specialNavi.show ? 'level1 is-open' : 'level1']" v-on:click="toggleList(specialNavi)">特集から探す</label>
  <transition>
  <div v-show="specialNavi.show">
	<ul class="sub-nav__catalog-special">
		<li><router-link :to="{name: 'catlist', params: {Name: '新'}}">新入荷商品</router-link></li>
		<li><router-link :to="{name: 'catlist', params: {Name: 'おすすめ'}}">おすすめ商品</router-link></li>
		<li><router-link :to="{name: 'catlist', params: {Name: '災害'}}">災害支援商品</router-link></li>
	</ul>
  </div>
  </transition -->
  <div class="acd-wrap">
	<div v-bind:class="[mainNavi.show ? 'side_ttl' : 'side_ttl acd-ttl']" v-on:click="toggleList(mainNavi)"><p>機種一覧から探す</p></div>
	<transition>
	<div v-if="mainNavi.show">
        <div v-for="category in sortCategories" v-bind:key="category.id">
          <ul class="acd-menu">
            <li>
              <p v-bind:class="[category.show ? 'acd-menu-ttl' : 'acd-menu-ttl acd-ttl']" v-on:click="toggleListInMainNavi(category, sortCategories)">
                {{category.name}}
              </p>
            </li>
            <transition>
            <div v-if="category.show">
              <ul class="acd-menu02">
                <div v-for="child in category.child" v-bind:key="child.id">
                  <li>
                    <div v-if="child.child.length > 0">
                      <p v-bind:class="[child.show ? 'acd-menu02' : 'acd-menu02']" v-on:click="toggleListInMainNavi(child, category.child)">
                        {{child.name}}
                      </p>
                    </div>
                    <div v-else>
                    <ul class="acd-menu02">
                      <li>
                        <router-link class="product" :to="{ name: 'list', params: {Id: child.id, CatName: child.name}}">{{child.name}}</router-link>
                      </li>
                    </ul>
                    </div>
                  </li>
                  <transition>
                  <div v-if="child.show">
                    <ul class="acd-menu02">
                    <div v-for="childone in child.child" v-bind:key="childone.id">
                      <li>
                        <router-link class="product" :to="{ name: 'list', params: {Id: childone.id}}">{{childone.name}}</router-link>
                      </li>
                    </div>
                    </ul>
                  </div>
                  </transition>
                </div>
              </ul>
            </div>
            </transition>
          </ul>
        </div>
	</div>
  </transition>
  </div>
  <div class="acd-wrap">
	<div v-bind:class="[docsNavi.show ? 'side_ttl' : 'side_ttl acd-ttl02']" v-on:click="toggleList(docsNavi)"><p>参考資料</p></div>
	<transition>
      <div v-show="docsNavi.show">
      <ul class="acd-menu">
        <li><a href="/../document/general-conditions.html">レンタル約款</a></li>
        <li><a href="https://dendousya.co.jp/pdf/article-rental-support201807.pdf">レンタル物件サポート特約制度</a></li>
        <li><a href="/../document/special-contract.html">レンタル保障制度</a></li>
        <li><a href="/../document/law.html">法規</a></li>
        <li><a href="/../document/qualification.html">資格</a></li>
        <li><a href="/../document/unit.html">単位</a></li>
        <li><a href="/../document/guide.html">ご利用ガイド</a></li>
      </ul>
      </div>
	</transition>
  </div>
</div>
</template>

<style>
</style>

<script>	
  export default {
    data: function () {
      return {
				specialNavi: {
					show: false
				},
				mainNavi: {
					show: false
				},
				docsNavi: {
					show: false
				},
        sortCategories: [] //categories
      }
    },
    props: {
      categorySet: {
        type: Array,
        require: true
      }
    },
    mounted () {
      this.sortCategories = this.categorySet
    },
    methods: {
      toggleList: function (menu){
        menu.show = !menu.show
      },
      toggleListInMainNavi: function (menu, uppermenus = []){
        for(var i=0;i<uppermenus.length;i++){
          uppermenus[i].show = false
        }
        this.mainNavi.show = false;
        menu.show = !menu.show;
        this.$nextTick(()=>{
          this.mainNavi.show = true;
        })
      },
    },
    watch: {
      categorySet(newSet){
        this.sortCategories = newSet
      }
    }
  }
</script>
